// src/routesTitle.js
const PREFIX = "TU Sofia Racing Team";

export const routeTitles = {
  "/": `${PREFIX} - Home`,
  "/about": `${PREFIX} - About Us`,
  "/about/our-cars": `${PREFIX} - Our Cars`,
  "/about/our-team": `${PREFIX} - Our Team`,
  "/about/our-history": `${PREFIX} - Our History`,
  "/about/join-us": `${PREFIX} - Join Us`,
  "/sponsors": `${PREFIX} - Our Sponsors`,
  "/gallery": `${PREFIX} - Gallery`,
  "/contacts": `${PREFIX} - Contact Us`,
  "*": `Page Not Found`,
};
